module.exports = __webpack_public_path__ + "static/volleyball-c3c79152c8ae8a5081c9dee0bf703da6.svg";